import type { DurationRangeType } from '../interfaces/courses-filter.interface';
import type { SingleParamType } from '../interfaces/paginated.interface';

export class CommonQuerySerializers {
  static booleanSerializer(key: string): SingleParamType<boolean | null> {
    return {
      key,
      serializerFn: (value) => value?.toString() ?? '',
      deserializeFn: (value) => {
        if (value === '') return null;
        return value === 'true';
      },
    };
  }

  static stringSerializer(key: string): SingleParamType<string | null> {
    return {
      key,
      serializerFn: (value) => value ?? '',
      deserializeFn: (value) => {
        if (value === '') return null;
        return value;
      },
    };
  }

  static numberSerializer(key: string): SingleParamType<number | null> {
    return {
      key,
      serializerFn: (value) => value?.toString() ?? '',
      deserializeFn: (value) => {
        if (value === '') return null;
        return Number(value);
      },
    };
  }

  static arraySerializer(key: string): SingleParamType<string[] | null> {
    return {
      key,
      serializerFn: (value) => value?.join(',') ?? '',
      deserializeFn: (value) => {
        if (!value) return [];
        return value.split(',');
      },
    };
  }
  static durationRangeSerializer(
    key: string
  ): SingleParamType<DurationRangeType[] | null> {
    return {
      key,
      serializerFn: (value) =>
        value
          ? value
              .map(
                (v) =>
                  `${v.min.duration}-${v.min.durationUnit}_${v.max.duration}-${v.max.durationUnit}`
              )
              .join(',')
          : '',
      deserializeFn: (value) => {
        if (!value) return [];

        return value.split(',').map((range) => {
          const [minStr, maxStr] = range.split('_');
          const [minDuration, minUnit] = minStr.split('-');
          const [maxDuration, maxUnit] = maxStr.split('-');

          return {
            min: {
              duration: Number(minDuration),
              durationUnit: minUnit as DurationRangeType['min']['durationUnit'],
            },
            max: {
              duration: Number(maxDuration),
              durationUnit: maxUnit as DurationRangeType['max']['durationUnit'],
            },
          };
        });
      },
    };
  }
}
